<template>
<div class="box">
  <van-field
      v-model="result"
      is-link
      readonly
      name="datetimePicker"
      input-align='right'
      :label="label"
      :placeholder="placeholder"
      @click="showPicker = true"
  />
  <van-popup v-model:show="showPicker" position="bottom">
    <van-datetime-picker
        type="date"
        v-model="currentTime"
        :formatter="formatter"
        @confirm="onConfirm"
        @cancel="showPicker = false"
    />
  </van-popup>
</div>
</template>

<script>
import moment from "moment"
export default {
  name: "Date",
  emits: ['update:modelValue','update:name'],
  props:{
    modelValue:Object,
    label:String,
    name:String,
    placeholder:String,
  },
  data(){
    return{
      result:"",
      currentTime:null,
      showPicker:false,
    }
  },

  mounted(){
    console.log(this.currentTime);
    console.log(this.modelValue);
      if(this.modelValue!=null){
        this.result=moment(this.value).format("YYYY-MM-DD")
      }
      if(this.currentTime==null){
        this.currentTime=new Date()
      }
  },

  methods:{

    onConfirm(value){
      console.log(value)
      this.result = moment(value).format("YYYY-MM-DD");
      this.$emit('update:name',this.result )
      this.$emit('update:modelValue',moment(value).unix())
      this.showPicker = false;
    },
     formatter:function(type, val) {
      if (type === 'year') {
        return `${val}年`;
      }
      if (type === 'month') {
        return `${val}月`;
      }
       if (type === 'day') {
         return `${val}日`;
       }
      return val;
    }
  }

}
</script>

<style scoped>
.box {
  width: 90%;
  margin-left: 5%;
  border-radius: 12px;
opacity: 1;
border: 1px solid rgba(36,202,164,0.5000);
margin-bottom: 10px;
}
.van-cell{
  border-radius: 12px;
}
</style>

